import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import { HomeSection } from '#client/components/Section';

import ChatAction from './ChatAction';
import { HelpSectionActions as Actions, HelpSectionActionItem as ActionItem } from './HelpSection.style';

function HelpSection() {
  return (
    <HomeSection title={<FormattedMessage id="dashboard.helpSection.title" />}>
      <Actions>
        <ActionItem>
          <ChatAction />
        </ActionItem>
      </Actions>
    </HomeSection>
  );
}

export default HelpSection;
